"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svgIcons_1 = require("../../../../svgIcons");
const customIcons = {
    0: {
        icon: react_1.default.createElement(svgIcons_1.RatingStar, null),
    },
    1: {
        icon: react_1.default.createElement(svgIcons_1.RatingStar, { fill: '#F9D601' }),
    },
    0.5: {
        icon: react_1.default.createElement(svgIcons_1.RatingHalfStar, null),
    },
};
const IconContainer = (props) => {
    const _a = props.props, { value } = _a, other = __rest(_a, ["value"]);
    const { rate } = props;
    if (value > rate && rate < 4.5) {
        return react_1.default.createElement("span", Object.assign({}, other), customIcons[0].icon);
    }
    if (value.toString().indexOf('.') > -1 || (value > rate && rate >= 4.5)) {
        return react_1.default.createElement("span", Object.assign({}, other), customIcons[0.5].icon);
    }
    return react_1.default.createElement("span", Object.assign({}, other), customIcons[1].icon);
};
exports.default = IconContainer;
